var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col px-0 d-flex content-detail"},[_c('contact-list',{attrs:{"selected-tab":_vm.tab}}),_vm._v(" "),_c('contact-topic',{attrs:{"contact":_vm.contact},on:{"closeCase":_vm.closeCase}}),_vm._v(" "),_c('contact-about',{attrs:{"contact":_vm.contact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }